import React from "react";
import { node } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";

const RechazoEcheck = ({ data }) => (
    <GridTable.Container columns={3} columnsTemplate="fixed">
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.rejection.dateTime"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={data?.fecha_hora} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.rejection.code"
                    titleTextType="I18N"
                    valueText={data?.codigo_rechazo ? data?.codigo_rechazo : "N/A"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.rejection.reason"
                    titleTextType="I18N"
                    valueText={data?.motivo_rechazo ? data?.motivo_rechazo : "N/A"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
    </GridTable.Container>
);

RechazoEcheck.propTypes = {
    data: node.isRequired,
};

export default RechazoEcheck;
